import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from 'src/contexts/AuthContext/AuthContext';
import { useLanguageNavigation } from 'src/hooks/use-language-navigation';

const LandingRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { accessToken, isAuthLoading } = useAuthContext();
  const { getLocalizedPath } = useLanguageNavigation();

  if (isAuthLoading) {
    return null;
  }

  if (accessToken) {
    return <Navigate to={getLocalizedPath('/home')} replace />;
  }

  return <>{children}</>;
};

export default LandingRoute;
